import { render } from "./InvestorSelectorWidget.vue?vue&type=template&id=724d2334"
import script from "./InvestorSelectorWidget.vue?vue&type=script&lang=js"
export * from "./InvestorSelectorWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__